"use strict";
import angular from "angular";
import finalApprovalHtmlUrl from "./views/finalApproval.html";
var app = angular.module("app.finalApproval.component", []);
app.component("finalApproval", {
    bindings: {
        showActions: "<",
        isEditForm: "<",
        model: "=",
        selectedFinalApprove: "=",
    },
    templateUrl: finalApprovalHtmlUrl,
    controller: function ($scope) {
        let self = this;
        self.checkboxValue = false;
        self.conditionMet = false;
        self.htmlFileUriName = null;
        self.liveSeedValidationFileUriName = null;

        self.checkboxChanged = function () {
            if (self.model) {
                let checkboxState = self.checkboxValue ? 1 : 0;
                let checkboxChangedObject = {
                    'is_final_approval': checkboxState
                };
                self.model.__final_approval = JSON.stringify(checkboxChangedObject);
            }
        };

        $scope.$watch(function () {
            return self.model ? self.model.__html_validation_status : null;
        }, function (newValue) {
            self.checkConditions();
        });

        $scope.$watch(function () {
            return self.model ? self.model.__creative_id : null;
        }, function (newValue) {
            self.checkConditions();
        });

        $scope.$watch(function () {
            return self.model ? self.model.__live_seed_list_id : null;
        }, function (newValue) {
            self.checkConditions();
        });

        $scope.$watch(function () {
            return self.model ? self.model.__live_seed_validation_status : null;
        }, function (newValue) {
            self.checkConditions();
        });

        $scope.$watch(function () {
            return self.model ? self.model.__banner_validation_status : null;
        }, function (newValue) {
            self.checkConditions();
        });

        $scope.$watch(function () {
            return self.model ? self.model.__has_critical_html_val_errors : null;
        }, function (newValue) {
            self.checkConditions();
        });

        $scope.$watch(function () {
            return self.model ? self.model.__send_time : null;
        }, function (newValue) {
            self.checkConditions();
        });

        $scope.$watch(function () {
            return self.model ? self.model.__send_date : null;
        }, function (newValue) {
            self.checkConditions();
        });

        $scope.$watch(function () {
            return self.model ? self.model.__links_and_main_cta : null;
        }, function (newValue) {
            // Clear the checkbox value but don't disable the final approval checkbox
            if (self.model && !self.hasMainCTASelected() && self.checkboxValue == 1) {
                self.checkboxValue = 0;
                self.checkboxChanged();
            }
        });

        $scope.$watch(function () {
            return self.model ? self.model.__html_file_uri : null;
        }, function (newValue) {
            self.checkConditions();

            // Clear checkbox if new file is being uploaded
            if (newValue &&
                newValue.length > 0 &&
                self.checkboxValue == 1 &&
                self.conditionMet &&
                self.htmlFileUriName &&
                (self.htmlFileUriName !== newValue[0]['name'] || newValue.length > 1)
            ) {
                self.checkboxValue = 0;
                self.checkboxChanged();
                self.conditionMet = false;
            }
        });

        $scope.$watch(function () {
            return self.model ? self.model.__live_seed_validation_file_uri : null;
        }, function (newValue) {
            self.checkConditions();

            // Clear checkbox if new file is being uploaded
            if (newValue &&
                newValue.length > 0 &&
                self.checkboxValue == 1 &&
                self.conditionMet &&
                self.liveSeedValidationFileUriName &&
                (self.liveSeedValidationFileUriName !== newValue[0]['name'] || newValue.length > 1)
            ) {
                self.checkboxValue = 0;
                self.checkboxChanged();
                self.conditionMet = false;
            }
        });

        self.initComponent = function () {
            if (self.model) {
                if (
                    self.model.__final_approval === null ||
                    self.model.__final_approval === undefined ||
                    self.model.__final_approval === ""
                ) {
                    var finalApprovalObject = {
                        'is_final_approval': 0
                    };
                    self.model.__final_approval = JSON.stringify(finalApprovalObject);
                }
                let checkboxValue = JSON.parse(self.model.__final_approval);
                self.checkboxValue = checkboxValue.is_final_approval === 1;

                if (self.model.__html_file_uri !== null &&
                    self.model.__html_file_uri !== undefined &&
                    self.model.__html_file_uri[0] !== undefined
                ) {
                    self.htmlFileUriName = self.model.__html_file_uri[0]['name'];
                }
    
                if (self.model.__live_seed_validation_file_uri !== null &&
                    self.model.__live_seed_validation_file_uri !== undefined &&
                    self.model.__live_seed_validation_file_uri[0] !== undefined
                ) {
                    self.liveSeedValidationFileUriName = self.model.__live_seed_validation_file_uri[0]['name'];
                }
                self.checkConditions();
            } else if (
                // Only update checkbox if the parent scope realizes a valid component model has been initialized
                self.selectedFinalApprove !== undefined &&
                self.selectedFinalApprove !== "" &&
                self.selectedFinalApprove !== null
            ) {
                let selectedValue = JSON.parse(self.selectedFinalApprove);
                self.checkboxValue = selectedValue.is_final_approval === 1;
            }
        };

        // This should only be called when a valid model exists
        self.hasMainCTASelected = function () {
            let hasMainCTASelected = false;
            if (self.model.__links_and_main_cta && self.model.__links_and_main_cta.length > 0) {
                let links = self.model.__links_and_main_cta;
                if (!Array.isArray(links)) {
                    links = JSON.parse(self.model.__links_and_main_cta);
                }
                
                for (let i = 0; i < links.length; i++) {
                    if (links[i].selected === true) {
                        hasMainCTASelected = true;
                        break;
                    }
                }
            }
            return hasMainCTASelected;
        };

        self.checkConditions = function () {
            // This should only run when there is a model to check and update
            if (self.model) {
                let isEmpty = (self.model.__send_date === null ||
                    self.model.__send_date === undefined ||
                    self.model.__send_date === "" ||
                    self.model.__has_critical_html_val_errors === "1" ||
                    self.model.__has_critical_html_val_errors === undefined ||
                    self.model.__has_critical_html_val_errors === true ||
                    self.model.__send_time === null ||
                    self.model.__send_time === undefined ||
                    self.model.__send_time === "" ||
                    self.model.__live_seed_list_id === null ||
                    self.model.__live_seed_list_id === undefined ||
                    self.model.__live_seed_list_id === "" ||
                    self.model.__live_seed_validation_status === null ||
                    self.model.__live_seed_validation_status === undefined ||
                    self.model.__live_seed_validation_status.toLowerCase() !== "success" ||
                    self.model.__320x50_banner_validation_status === null ||
                    self.model.__320x50_banner_validation_status === undefined ||
                    self.model.__320x50_banner_validation_status.toLowerCase() !== "success" ||
                    self.model.__728x90_banner_validation_status === null ||
                    self.model.__728x90_banner_validation_status === undefined ||
                    self.model.__728x90_banner_validation_status.toLowerCase() !== "success" ||
                    self.model.__banner_validation_status === null ||
                    self.model.__banner_validation_status === undefined ||
                    self.model.__banner_validation_status.toLowerCase() !== "success" ||
                    self.model.__creative_id === null ||
                    self.model.__creative_id === undefined ||
                    self.model.__creative_id === "" ||
                    self.model.__html_validation_status === null ||
                    self.model.__html_validation_status === undefined ||
                    self.model.__html_validation_status.toLowerCase() !== "success" ||
                    self.model.__main_cta_status === null ||
                    self.model.__main_cta_status === undefined ||
                    self.model.__main_cta_status.toLowerCase() !== "success"
                );
                
                self.conditionMet = (!isEmpty && self.hasMainCTASelected());

                if (!self.conditionMet && self.checkboxValue == 1) {
                    self.checkboxValue = 0;
                    self.checkboxChanged();
                }
            }
        };

        self.initComponent();
    },
});